import { render, staticRenderFns } from "./NoContent3.vue?vue&type=template&id=b99aa58a&scoped=true"
import script from "./NoContent3.vue?vue&type=script&lang=js"
export * from "./NoContent3.vue?vue&type=script&lang=js"
import style0 from "./NoContent3.vue?vue&type=style&index=0&id=b99aa58a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99aa58a",
  null
  
)

export default component.exports